var render, staticRenderFns
import script from "./_Base.vue?vue&type=script&lang=ts&"
export * from "./_Base.vue?vue&type=script&lang=ts&"
import style0 from "./_Base.vue?vue&type=style&index=0&id=609970a0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "609970a0",
  null
  
)

export default component.exports